import { Link, useLocation } from 'react-router-dom'
import './Breadcrumb.css'

// Define breadcrumb mappings
const breadcrumbMap = {
  '/': { label: 'Home', path: '/' },
  '/quick-start': { label: 'Quick Start', path: '/quick-start', parent: '/' },
  '/platform-capabilities/apps': { label: 'Apps', path: '/platform-capabilities/apps', parent: '/platform-capabilities' },
  '/platform-capabilities/registry': { label: 'Registry', path: '/platform-capabilities/registry', parent: '/platform-capabilities' },
  // '/platform-capabilities/cloud-storage': { label: 'Cloud Storage', path: '/platform-capabilities/cloud-storage', parent: '/platform-capabilities' }, // Hidden for now
  '/platform-capabilities/database': { label: 'Database', path: '/platform-capabilities/database', parent: '/platform-capabilities' },
  '/platform-capabilities/vps': { label: 'VPS', path: '/platform-capabilities/vps', parent: '/platform-capabilities' },
  '/platform-capabilities': { label: 'Platform Capabilities', path: '/platform-capabilities', parent: '/' },
  '/account/billing': { label: 'Billing', path: '/account/billing', parent: '/account' },
  '/account/usage': { label: 'Usage', path: '/account/usage', parent: '/account' },
  '/account': { label: 'Account', path: '/account', parent: '/' },
  '/resources/api-keys': { label: 'API Keys', path: '/resources/api-keys', parent: '/resources' },
  '/resources/vscode-extension': { label: 'VS Code Extension', path: '/resources/vscode-extension', parent: '/resources' },
  '/resources/faq': { label: 'FAQ', path: '/resources/faq', parent: '/resources' },
  '/resources/support': { label: 'Support', path: '/resources/support', parent: '/resources' },
  '/resources/community': { label: 'Community', path: '/resources/community', parent: '/resources' },
  '/resources': { label: 'Resources', path: '/resources', parent: '/' }
}

const Breadcrumb = () => {
  const location = useLocation()
  const currentPath = location.pathname

  // Show "Home" as current page on home page
  if (currentPath === '/') {
    return (
      <nav className="breadcrumb">
        <span className="breadcrumb-current">Home</span>
      </nav>
    )
  }

  const buildBreadcrumbs = () => {
    const breadcrumbs = []
    let current = breadcrumbMap[currentPath]

    if (!current) {
      return null
    }

    // Build breadcrumb chain
    const chain = []
    let item = current
    while (item) {
      chain.unshift(item)
      item = item.parent ? breadcrumbMap[item.parent] : null
    }

    // Only add Home if it's not already the first item
    if (chain.length === 0 || chain[0].path !== '/') {
      chain.unshift(breadcrumbMap['/'])
    }

    return chain
  }

  const breadcrumbs = buildBreadcrumbs()

  if (!breadcrumbs || breadcrumbs.length <= 1) {
    return null
  }

  return (
    <nav className="breadcrumb">
      {breadcrumbs.map((crumb, index) => {
        const isLast = index === breadcrumbs.length - 1
        return (
          <span key={crumb.path}>
            {isLast ? (
              <span className="breadcrumb-current">{crumb.label}</span>
            ) : (
              <>
                <Link to={crumb.path}>{crumb.label}</Link>
                <span className="breadcrumb-separator">→</span>
              </>
            )}
          </span>
        )
      })}
    </nav>
  )
}

export default Breadcrumb
